import { CommonAlertService } from './../../services/common-alert.service';
import { ConfirmationModalComponent } from './../confirmation-modal/confirmation-modal.component';
import { MasterService } from '../../home/services/master.service';
import { ProductViewModalComponent } from './../product-view-modal/product-view-modal.component';
import { filter } from 'rxjs/operators';
import { StockService } from '../../home/services/stocks.service';

import {
  Component,
  Inject,
  OnInit,
  ViewChild,
  ElementRef,
  AfterViewInit,
  ViewChildren,
  QueryList
} from '@angular/core';
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog
} from '@angular/material/dialog';
import { MatDatepickerModule } from '@angular/material/datepicker';

@Component({
  selector: 'app-purchaseorder-modal',
  templateUrl: './purchaseorder-modal.component.html',
  styleUrls: ['./purchaseorder-modal.component.scss']
})
export class PurchaseorderModalComponent implements AfterViewInit, OnInit {
  @ViewChild('addAtribute', { static: false })
  addAtribute: ElementRef;
  public newRow: any;
  public invoiceData: any;
  public selectedLocation: any;
  public locationData: any;
  public Countries: any;
  public totals = {
    gT: 0,
    d: 0,
    nT: 0
  };

  public headObj = {
    datePick: new Date().toLocaleDateString(),
    // datePick: '2019-11-26',
    coutry: '',
    warehouse: ''
  };

  public editHeadObj = {
     dataPick: '',
    /*dataPick: '',*/
    country: '',
    warehouse: ''
  };

  public indexTotals = {
    total: 0
  };

  public productResult: Array<any> = [
    {
      code: '',
      name: '',
      quantity: '',
      rate: '',
      discount: '',
      amount: ''
    }
  ];

  public editTotal = {
    gt: 0,
    nt: 0,
    d: 0
  };
  public rateToBe: any;
  public quantityToBe: any;
  public changeAmount: number;
  public today: Date;
  // public qn: any;
  // public rt: any;
  @ViewChild('myInput', { static: true })
  myInput: ElementRef;
  public mymodel: any;
  public selectedQn: any;
  // tslint:disable-next-line:variable-name
  public total_amount: any;
  // tslint:disable-next-line:variable-name
  public total_dis: any;
  public editId: any;
  public idEnc: any;
  public editFormData: any = {};
  public editObj: any = {};
  public items: any = {};
  public viewPermission = false;
  public editPermission = false;
  public approvalPermission = false;
  public reorderPermission = false;
  public submitType = 'New';
  public reorderStatus = 'No';

  constructor(
    public dialogRef: MatDialogRef<PurchaseorderModalComponent>,
    @Inject(MAT_DIALOG_DATA) data,
    public stockService: StockService,
    public dialog: MatDialog,
    public masterService: MasterService,
    public alrtService: CommonAlertService
  ) {

    if (data) {
      this.editId = data.id,
      this.idEnc = data.enc_Id;
    }
  }

  ngAfterViewInit() {
    // console.log(this.newRow);
  }

  ngOnInit() {
    // @ts-ignore
    // tslint:disable-next-line:triple-equals
    if (localStorage.getItem('roleId') == 0) {
      // @ts-ignore
      // tslint:disable-next-line:max-line-length
      this.editPermission = this.approvalPermission = this.reorderPermission = true;
    } else {
      const roles = JSON.parse(localStorage.getItem('roles'));
      // tslint:disable-next-line:triple-equals
      if (roles['purchase_order.add'] == 1) {
        this.reorderPermission = true;
      }
      // tslint:disable-next-line:triple-equals
      if (roles['purchase_order.edit'] == 1) {
        this.editPermission = true;
      }
      // tslint:disable-next-line:triple-equals
      if (roles['purchase_order.approval'] == 1) {
        this.approvalPermission = true;
      }
    }


    console.log(this.approvalPermission);
    // tslint:disable-next-line:variable-name
    const url = '/purchase_orders/get_data';
    const id = 0;

    this.stockService.getLocations().subscribe(res => {
      // @ts-ignore
      this.invoiceData = res.data.items;
    });

    this.masterService.getData('/countries/get').subscribe(res => {
      // @ts-ignore
      this.Countries = res.data;

    });

    //alert (this.Countries.name);


  if(this.Countries){
   // console.log(JSON.stringify(this))
    alert (Object.values(this.Countries || {}));
  }

    if (this.editId) {
      this.masterService.getRecordById(this.editId, this.idEnc, url)
        .subscribe(res => {
          this.approvalPermission = true;
          this.reorderPermission = false;
          this.editPermission = true;
          // @ts-ignore
          this.invc_editD = res.data;
          // @ts-ignore
          this.editHeadObj.dataPick = res.data.purchase_order.po_date;
          // @ts-ignore
          if (res.data.purchase_order.status !== 'New') {
            this.approvalPermission = false;
            this.reorderPermission = true;
            this.editPermission = false;
          }
          // @ts-ignore
          // tslint:disable-next-line:variable-name
          const get_date = new Date(res.data.purchase_order.created_at);
          let dd: any = get_date.getDate();
          let mm: any = get_date.getMonth() + 1;
          const yyyy = get_date.getFullYear();
          if (dd < 10) {
            dd = '0' + dd;
          }
          if (mm < 10) {
            mm = '0' + mm;
          }
          this.editHeadObj.dataPick = dd + '/' + mm + '/' + yyyy;
          //this.editHeadObj.dataPick = (get_date.getDate()) + '/' + (get_date.getMonth() + 1) + '/' +  get_date.getFullYear();

          // @ts-ignore
          this.editHeadObj.country = res.data.purchase_order.country_id;

          // @ts-ignore
          this.selectedEdiTLocationFn(res.data.purchase_order.country_id);
          // @ts-ignore
          this.editHeadObj.warehouse = res.data.purchase_order.city_id;


          // @ts-ignore
          this.items = res.data.purchase_order_item;
          // @ts-ignore
          this.editObj = res.data.purchase_order;
          this.editTotal.gt = this.editObj.grand_total;
          this.editTotal.nt = this.editObj.net_total;
          this.cal();
        });
    }

  }
//alert(this.editHeadObj.country);


  close() {
    this.dialogRef.close();
  }

  addRow() {

    const obj = {
      code: '',
      name: '',
      quantity: '',
      rate: '',
      discount: '',
      amount: ''
      };

    if (!this.editId) {
      this.productResult.push(obj);
    } else {
      this.items.push(obj);
    }

  }

  deleteRow(index) {

    if (!this.editId) {
      // tslint:disable-next-line:triple-equals
      if (index == 0) {
        return;
      } else {
        this.productResult.splice(index, 1);
      }
    } else {
      // tslint:disable-next-line:triple-equals
      if (index == 0) {
        return;
      } else {
        this.items.splice(index, 1);
      }
    }
    this.cal();

  }

  selectedLocationFn(event: Event) {

    this.locationData = this.invoiceData.filter(
      // tslint:disable-next-line:triple-equals
     r => this.selectedLocation == r.country_id
    );

  }




  selectedEdiTLocationFn(val) {
    const selectedLoc = val;
    this.locationData = this.invoiceData.filter(
      // tslint:disable-next-line:triple-equals
      r => selectedLoc == r.country_id
    );
  }

  openProductModal(pro) {
    const dialogRef = this.dialog
      .open(ProductViewModalComponent, {
        maxWidth: '100vw',
        maxHeight: '100vh',
        width: '900px',
        height: '50vh',
        disableClose: true
      })
      .afterClosed()
      .subscribe(res => {

        // tslint:disable-next-line:variable-name
        console.log(this.editId);
        let total_amount: (string | PaymentCurrencyAmount | number)[];
        if (!this.editId) {

          //this.productResult.push(res.data);
          //this.productResult.splice(this.productResult.length - 2, 1);
          this.productResult.splice( pro, 1,res.data );
          total_amount = this.productResult.map(r => r.amount);

          // @ts-ignore
          this.total_amount = total_amount.reduce((a, b) => a + b, 0);
          this.cal();
        } else {

         // this.items.push(res.data);
          //this.items.splice(this.items.length - 2, 1);
          this.items.splice(pro,1,res.data);
          this.cal();
        }


      });
  }

  blur(eve, type, i) {

    if (!this.editId) {
      this.productResult[i][type] = (parseFloat(eve.target.value))?parseFloat(eve.target.value):0;
      // tslint:disable-next-line:max-line-length
      this.productResult[i].rate = (this.productResult[i].amount * this.productResult[i].quantity) - ((this.productResult[i].discount / 100)  * (this.productResult[i].amount * this.productResult[i].quantity));
    } else {
      this.items[i][type] = (parseFloat(eve.target.value))?parseFloat(eve.target.value):0;
      // tslint:disable-next-line:max-line-length
      this.items[i].rate = (this.items[i].amount * this.items[i].quantity) - ((this.items[i].discount / 100)  * (this.items[i].amount * this.items[i].quantity));
    }
    this.cal();
  }

  blurDis(eve) {
    if (!this.editId) {
      this.totals.d = parseFloat(eve.target.value);
      this.cal();
    } else {
      this.editTotal.d = parseFloat(eve.target.value);
      this.cal();
    }

  }

  cal() {
    // tslint:disable-next-line:one-variable-per-declaration
    let sum = 0;
    let disc = 0;
    if (!this.editId) {
      //  let sum = 0, disc = 0, nt = 0;
      this.productResult.map(item => {
        if (!isNaN(item.amount) && !isNaN(item.quantity) && !isNaN(item.discount)) {
          sum += item.amount * item.quantity;
          disc += (item.discount / 100) * (item.amount * item.quantity);
        }
      });
      this.totals.gT = sum;
      this.totals.nT = sum - disc;
      this.totals.d = disc;
    } else {
      this.items.map(item => {
        if (!isNaN(item.amount) && !isNaN(item.quantity) && !isNaN(item.discount)) {
          sum += item.amount * item.quantity;
          disc += (item.discount / 100) * (item.amount * item.quantity);
        }
      });
      this.editTotal.gt = sum;
      this.editTotal.nt = sum - disc;
      this.editTotal.d = disc;
    }
  }


  calculate() {
    // tslint:disable-next-line:variable-name
    const quantity_cal: any = (document.getElementById(
      'value1'
    ) as HTMLInputElement).value;
    // tslint:disable-next-line:variable-name
    const rate_cal: any = (document.getElementById('value2') as HTMLInputElement)
      .value;
    this.changeAmount = quantity_cal * rate_cal;
  }

  submitTypeChange() {
    this.submitType = 'Approved';
  }

  submitReorder() {
    this.reorderStatus = 'Yes';
  }

  submitForm(val) {
    if (!this.editId || this.reorderStatus === 'Yes') {
    const url = '/purchase_orders/store';
      // tslint:disable-next-line:variable-name
    const form_data = {};
    if (this.reorderStatus === 'Yes') {
      Object.assign(form_data, {
        token: localStorage.getItem('token'),
        grand_total: this.editTotal.gt,
        total_discount: this.editTotal.d,
        country_id: this.editHeadObj.country,
        city_id: this.editHeadObj.warehouse,
        net_total: this.editTotal.nt,
        po_date: this.editHeadObj.dataPick,
        purchase_order_products: this.items
      });


    } else {
      Object.assign(form_data, {
        token: localStorage.getItem('token'),
        grand_total: this.totals.gT,
        total_discount: this.totals.d,
        country_id: this.selectedLocation,
        city_id: this.headObj.warehouse,
        net_total: this.totals.nT,
        po_date: this.headObj.datePick,
        purchase_order_products: this.productResult
      });
    }

    // return false;

    this.masterService.addEditRecord(form_data, url).subscribe(res => {
      // @ts-ignore
      if (res.success) {
          this.alrtService.showSuccessMsg({message: 'Record Added Successfully'});
        }
    });

    this.close();

  } else {

    const url = '/purchase_orders/update';
    Object.assign(this.editFormData, {
      token: localStorage.getItem('token'),
      id: this.editId,
      enc_id: this.idEnc,
      grand_total: this.editTotal.gt,
      total_discount: this.editTotal.d,
      country_id: this.editHeadObj.country,
      city_id: this.editHeadObj.warehouse,
      net_total: this.editTotal.nt,
      po_date: this.editHeadObj.dataPick,
      purchase_order_products: this.items,
      status: this.submitType
    });

    this.masterService.addEditRecord(this.editFormData, url).subscribe(res => {
      // @ts-ignore
      if (res.success) {
        this.alrtService.showSuccessMsg({message: 'Record Updated Successfully'});
        }
    });

    this.close();

  }
 }

  confirmationModal(i, row) {
    // tslint:disable-next-line:variable-name
    const product_id = row.id;
    const dialogRef = this.dialog.open(ConfirmationModalComponent, {
      minWidth: '50vw',
      minHeight: '20vh',
      disableClose: true,
      data: product_id
    });
  }

}
